module.exports = __webpack_public_path__ + "img/car.193fbf8f.jpg";